import { Injectable } from "@angular/core";
import LoggerService from "@bfx/logger/dist";

const logger = LoggerService.for(__dirname);

/**
 * Service providing native HTML notification functionality. The sdervice will check existing permissions
 * and ask for permissions if none have been sought
 */
@Injectable()
export class NativeNotificationService {
  private permissionPromise: Promise<boolean>;

  constructor() {}

  /**
   * Determine if notifications permissions have already been given - if they have not been denied, then this
   * will request the user permission
   * @returns Promise with result of permsission request
   */
  protected getPermission(): Promise<boolean> {
    if (this.permissionPromise == null) {
      if (Notification.permission === "granted") {
        logger.out.info("natnot-s Notification permission already granted");
        this.permissionPromise = Promise.resolve(true);
      } else if (Notification.permission !== "denied") {
        this.permissionPromise = Notification.requestPermission().then((result) => {
          if (result === "denied") {
            logger.out.warn(
              "natnot-s Notification Permission wasn't granted. Logging may be degraded.",
            );
            return false;
          }
          if (result === "default") {
            logger.out.warn(
              "natnot-s Notification Permission was ignored. Logging may be degraded.",
            );
            return false;
          }
          if (result === "granted") {
            logger.out.info("natnot-s Notification Permission was granted.");
            return true;
          }
        });
      } else {
        logger.out.info("natnot-s Notification permission already denied");
        this.permissionPromise = Promise.resolve(false);
      }
    }
    return this.permissionPromise;
  }

  /**
   *  If allowed, pop up a desktop notification with the specified title and body
   * @param title
   * @param body
   * @returns
   */
  public openNotification(title: string, body: string): Promise<boolean> {
    logger.out.info(`natnot-s Opening new notification ${title}`);
    let result = this.getPermission().then((result) => {
      if (result) {
        logger.out.info(`natnot-s Permission given - showing notification ${title}`);
        // Create and show the notification
        const img = "./assets/images/favicon.svg";
        new Notification(title, { body, icon: img });
        return true;
      } else {
        logger.out.info(`natnot-s Cannot show notification ${title} - permission not given`);
        return false;
      }
    });

    return result;
  }
}
